export const COMMUNITY_MANAGER = "community manager";
export const COMMUNITY_ACCOUNTANT = "community accountant";
